import React, { createContext, useState, useContext } from 'react';
import TokenGeneratedModal from '../components/auth/TokenGeneratedModal';

// Create context
const TokenModalContext = createContext(null);

// Custom hook to use the context
export const useTokenModal = () => {
  const context = useContext(TokenModalContext);
  if (!context) {
    throw new Error('useTokenModal must be used within a TokenModalProvider');
  }
  return context;
};

// Provider component
export const TokenModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [token, setToken] = useState(null);
  const [studentName, setStudentName] = useState('');

  // Function to show the token modal
  const showTokenModal = (tokenValue, name) => {
    console.log('TokenModalContext: Showing token modal with token:', tokenValue);
    setToken(tokenValue);
    setStudentName(name);
    setIsOpen(true);
  };

  // Function to hide the token modal
  const hideTokenModal = () => {
    console.log('TokenModalContext: Hiding token modal');
    setIsOpen(false);
  };

  // Value to be provided by the context
  const value = {
    showTokenModal,
    hideTokenModal
  };

  return (
    <TokenModalContext.Provider value={value}>
      {children}
      <TokenGeneratedModal
        isOpen={isOpen}
        onClose={hideTokenModal}
        token={token}
        studentName={studentName}
      />
    </TokenModalContext.Provider>
  );
};

export default TokenModalContext;